import { createAction, props } from '@ngrx/store';

import { Translations } from '@vi-iot/client';

import { ViGuideChangeLog } from './changelog.model';

export namespace UpdatesActions {
  export enum Type {
    GET_VIGUIDE_UPDATES = '[UPDATES] Get ViGuide Updates',
    GET_VIGUIDE_UPDATES_SUCCESS = '[UPDATES] Get ViGuide Updates Success',
    GET_VIGUIDE_UPDATES_ERROR = '[UPDATES] Get ViGuide Updates Error',

    GET_VICARE_UPDATES = '[UPDATES] Get ViCare Updates',
    GET_VICARE_UPDATES_SUCCESS = '[UPDATES] Get ViCare Updates Success',
    GET_VICARE_UPDATES_ERROR = '[UPDATES] Get ViCare Updates Error',
  }

  export const getViGuideUpdates = createAction(Type.GET_VIGUIDE_UPDATES);

  export const getViGuideUpdatesSuccess = createAction(
    Type.GET_VIGUIDE_UPDATES_SUCCESS,
    props<{
      updates: ViGuideChangeLog[];
    }>()
  );

  export const getViGuideUpdatesError = createAction(Type.GET_VIGUIDE_UPDATES_ERROR);

  export const getViCareUpdates = createAction(Type.GET_VICARE_UPDATES);

  export const getViCareUpdatesSuccess = createAction(
    Type.GET_VICARE_UPDATES_SUCCESS,
    props<{
      translations: Translations;
    }>()
  );

  export const getViCareUpdatesError = createAction(Type.GET_VICARE_UPDATES_ERROR);
}
